import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesSection"] */ "/app/src/components/frontend/FeaturesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroBannerPlayBlock"] */ "/app/src/components/frontend/HeroBannerPlayBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductsSection"] */ "/app/src/components/frontend/ProductsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RedStatisticsBand"] */ "/app/src/components/frontend/RedStatisticsBand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchAndAction"] */ "/app/src/components/frontend/SearchAndAction.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/frontend/ZoomableImage.tsx");
